export default __webpack_public_path__ + "static/media/twitter_rounded.a6f7a885.svg";